(function (root, factory) {
  'use strict';

  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.FunnyHooksEventsCustomerViewModel = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  var CUSTOMER_STATES = {
    AVAILABLE: 'AVAILABLE',
    REGISTERING: 'REGISTERING',
    REGISTERED: 'REGISTERED',
    CANCELLED: 'CANCELLED',
    SOLD_OUT: 'SOLD_OUT',
    UNAVAILABLE: 'UNAVAILABLE',
    HELD_FOR_CUSTOMER: 'HELD_FOR_CUSTOMER',
    PAYMENT_PROCESSING: 'PAYMENT_PROCESSING',
    BOOKED: 'BOOKED',
    REVIEW_IN_PROGRESS: 'REVIEW_IN_PROGRESS'
  };

  var ERROR_CATEGORIES = {
    TEMPORARY_FAILURE: 'TEMPORARY_FAILURE',
    AUTHENTICATION_REQUIRED: 'AUTHENTICATION_REQUIRED',
    PLACE_NO_LONGER_AVAILABLE: 'PLACE_NO_LONGER_AVAILABLE',
    HOLD_EXPIRED: 'HOLD_EXPIRED',
    CART_REQUIRES_CLEANUP: 'CART_REQUIRES_CLEANUP',
    PAYMENT_CONFIRMATION_PENDING: 'PAYMENT_CONFIRMATION_PENDING',
    MANUAL_REVIEW: 'MANUAL_REVIEW'
  };

  function text(value) {
    return typeof value === 'string' ? value.trim() : '';
  }

  function finiteNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function runtimeState(input) {
    return text(input && input.runtimeState).toLowerCase();
  }

  function bookingMode(input) {
    var mode = text(input && input.bookingMode).toLowerCase();
    return mode === 'free' || mode === 'shopify_checkout' ? mode : 'none';
  }

  function isSoldOut(input) {
    var available = finiteNumber(input && input.available);
    return available !== null && available <= 0;
  }

  function normalizeFreeState(input) {
    var state = runtimeState(input);
    if (state === 'reserved') return CUSTOMER_STATES.REGISTERED;
    if (input && input.pending) return CUSTOMER_STATES.REGISTERING;
    if (state === 'cancelled_local') return CUSTOMER_STATES.CANCELLED;
    if (isSoldOut(input) || state === 'full') return CUSTOMER_STATES.SOLD_OUT;
    if (state === 'error' || state === 'unavailable') return CUSTOMER_STATES.UNAVAILABLE;
    return CUSTOMER_STATES.AVAILABLE;
  }

  function normalizePaidState(input) {
    var state = runtimeState(input);
    if (state === 'paid_reserved') return CUSTOMER_STATES.BOOKED;
    if (state === 'review_needed') return CUSTOMER_STATES.REVIEW_IN_PROGRESS;
    if (state === 'finalizing') return CUSTOMER_STATES.PAYMENT_PROCESSING;
    if (state === 'reserved' || state === 'paid_cart_added' || state === 'paid_checkout_link_failed') {
      return CUSTOMER_STATES.HELD_FOR_CUSTOMER;
    }
    if (input && input.pending) return CUSTOMER_STATES.HELD_FOR_CUSTOMER;
    if (
      isSoldOut(input) ||
      state === 'full' ||
      state === 'price_missing' ||
      state === 'variant_unavailable' ||
      state === 'paid_checkout_precheck_failed' ||
      state === 'error' ||
      state === 'unavailable'
    ) {
      return CUSTOMER_STATES.UNAVAILABLE;
    }
    return CUSTOMER_STATES.AVAILABLE;
  }

  function normalizeCustomerState(input) {
    var mode = bookingMode(input);
    if (mode === 'free') return normalizeFreeState(input || {});
    if (mode === 'shopify_checkout') return normalizePaidState(input || {});
    return CUSTOMER_STATES.UNAVAILABLE;
  }

  function normalizeErrorCategory(input, normalizedState) {
    var supplied = text(input && input.errorCategory).toUpperCase();
    if (Object.prototype.hasOwnProperty.call(ERROR_CATEGORIES, supplied)) return supplied;
    if (normalizedState === CUSTOMER_STATES.REVIEW_IN_PROGRESS) return ERROR_CATEGORIES.MANUAL_REVIEW;
    if (normalizedState === CUSTOMER_STATES.PAYMENT_PROCESSING) return ERROR_CATEGORIES.PAYMENT_CONFIRMATION_PENDING;
    if (normalizedState === CUSTOMER_STATES.SOLD_OUT || isSoldOut(input)) return ERROR_CATEGORIES.PLACE_NO_LONGER_AVAILABLE;
    if (!(input && input.loggedIn)) return ERROR_CATEGORIES.AUTHENTICATION_REQUIRED;
    if (runtimeState(input) === 'paid_checkout_precheck_failed') return ERROR_CATEGORIES.CART_REQUIRES_CLEANUP;
    return normalizedState === CUSTOMER_STATES.UNAVAILABLE ? ERROR_CATEGORIES.TEMPORARY_FAILURE : '';
  }

  function action(kind, enabled, labelKey) {
    return { kind: kind, enabled: !!enabled, labelKey: labelKey || '' };
  }

  function getCustomerActions(input, normalizedState) {
    var mode = bookingMode(input);
    var state = normalizedState || normalizeCustomerState(input || {});
    if (state === CUSTOMER_STATES.AVAILABLE) {
      if (!(input && input.loggedIn)) return action('LOGIN', true, 'customer_action.login');
      return mode === 'free'
        ? action('REGISTER', true, 'customer_action.register')
        : action('START_HOLD', true, 'customer_action.start_hold');
    }
    if (state === CUSTOMER_STATES.REGISTERED) return action('MANAGE_BOOKING', true, 'customer_action.manage_booking');
    if (state === CUSTOMER_STATES.CANCELLED) return action('REGISTER', true, 'customer_action.register_again');
    if (state === CUSTOMER_STATES.HELD_FOR_CUSTOMER) {
      if (runtimeState(input) === 'paid_checkout_link_failed') return action('OPEN_CART', true, 'customer_action.open_cart');
      return action('CONTINUE_CHECKOUT', true, 'customer_action.continue_checkout');
    }
    if (state === CUSTOMER_STATES.BOOKED) return action('VIEW_BOOKING', true, 'customer_action.view_booking');
    if (state === CUSTOMER_STATES.UNAVAILABLE) {
      if (runtimeState(input) === 'paid_checkout_precheck_failed') {
        return action('REMOVE_EVENT_LINE', true, 'customer_action.remove_event_line');
      }
      return action('RETRY', true, 'customer_action.retry');
    }
    if (
      state === CUSTOMER_STATES.REGISTERING ||
      state === CUSTOMER_STATES.PAYMENT_PROCESSING ||
      state === CUSTOMER_STATES.REVIEW_IN_PROGRESS
    ) {
      return action('WAIT', false, 'customer_action.wait');
    }
    return action('NONE', false, '');
  }

  function getCustomerPricePresentation(input) {
    if (bookingMode(input) !== 'shopify_checkout') return { status: 'NOT_APPLICABLE', display: '' };
    var display = text(input && input.priceDisplay);
    if (display) return { status: 'AVAILABLE', display: display };
    return input && input.priceRequired
      ? { status: 'MISSING', display: '' }
      : { status: 'OPTIONAL', display: '' };
  }

  function getCustomerAvailabilityPresentation(input) {
    var available = finiteNumber(input && input.available);
    var total = finiteNumber(input && input.total);
    if (available === null || total === null) return { status: 'UNKNOWN', available: null, total: null };
    return {
      status: available <= 0 ? 'SOLD_OUT' : 'AVAILABLE',
      available: Math.max(0, available),
      total: Math.max(0, total)
    };
  }

  function formatCountdown(seconds) {
    var safeSeconds = Math.max(0, Math.floor(seconds));
    var minutes = Math.floor(safeSeconds / 60);
    var remainder = String(safeSeconds % 60).padStart(2, '0');
    return String(minutes) + ':' + remainder;
  }

  function getCustomerCountdownPresentation(input, normalizedState) {
    var state = normalizedState || normalizeCustomerState(input || {});
    var seconds = finiteNumber(input && input.countdownSeconds);
    var activeState = state === CUSTOMER_STATES.HELD_FOR_CUSTOMER || state === CUSTOMER_STATES.PAYMENT_PROCESSING;
    if (!activeState || seconds === null || seconds <= 0) {
      return { status: 'INACTIVE', secondsRemaining: 0, display: '' };
    }
    return { status: 'ACTIVE', secondsRemaining: Math.floor(seconds), display: formatCountdown(seconds) };
  }

  function getCustomerRecoveryAction(input, normalizedState, errorCategory) {
    var state = normalizedState || normalizeCustomerState(input || {});
    var category = errorCategory || normalizeErrorCategory(input || {}, state);
    if (category === ERROR_CATEGORIES.AUTHENTICATION_REQUIRED) return action('LOGIN', true, 'customer_action.login');
    if (category === ERROR_CATEGORIES.CART_REQUIRES_CLEANUP) {
      return action('REMOVE_EVENT_LINE', true, 'customer_action.remove_event_line');
    }
    if (category === ERROR_CATEGORIES.HOLD_EXPIRED || category === ERROR_CATEGORIES.TEMPORARY_FAILURE) {
      return action('RETRY', true, 'customer_action.retry');
    }
    return action('NONE', false, '');
  }

  function messageKey(input, normalizedState) {
    var mode = bookingMode(input) === 'shopify_checkout' ? 'paid' : 'free';
    return 'customer_state.' + mode + '.' + normalizedState.toLowerCase();
  }

  function buildCustomerViewModel(input) {
    var source = input || {};
    var normalizedState = normalizeCustomerState(source);
    var errorCategory = normalizeErrorCategory(source, normalizedState);
    return {
      state: normalizedState,
      messageKey: messageKey(source, normalizedState),
      primaryAction: getCustomerActions(source, normalizedState),
      price: getCustomerPricePresentation(source),
      availability: getCustomerAvailabilityPresentation(source),
      countdown: getCustomerCountdownPresentation(source, normalizedState),
      errorCategory: errorCategory,
      recoveryAction: getCustomerRecoveryAction(source, normalizedState, errorCategory)
    };
  }

  return {
    CUSTOMER_STATES: CUSTOMER_STATES,
    ERROR_CATEGORIES: ERROR_CATEGORIES,
    normalizeCustomerState: normalizeCustomerState,
    getCustomerActions: getCustomerActions,
    getCustomerPricePresentation: getCustomerPricePresentation,
    getCustomerAvailabilityPresentation: getCustomerAvailabilityPresentation,
    getCustomerCountdownPresentation: getCustomerCountdownPresentation,
    getCustomerRecoveryAction: getCustomerRecoveryAction,
    buildCustomerViewModel: buildCustomerViewModel
  };
});
